import { getApiBaseUrl } from "../utils/config";
import { getAccessToken } from "../components/Utils/Utils";

// Ends this browser's session on the server, so the token stops working even
// if it was copied somewhere; other devices of a parallel-login license stay
// logged in. Plain fetch with keepalive instead of http: the request has to
// survive the reload that follows, and an already invalid token must not
// trigger the "session expired" handling of the http interceptor.
export const logoutSession = () => {
  const token = getAccessToken();
  if (!token) {
    return;
  }
  fetch(`${getApiBaseUrl()}/de/react/${token}/logout`, {
    method: "POST",
    keepalive: true,
    headers: { Accept: "application/json" },
  }).catch(() => {});
};
